export const colors = {
  NEAR_WHITE: '#fbfbfa',
  OLIVE: '#4A4800',
  SUN_FLOWER: '#FFBB00',
  LEMON_LIME: '#E4EA8C',
};
